import { CircleCheck, Info, LoaderCircle, OctagonX, TriangleAlert } from 'lucide-react';
import { Toaster as Sonner, toast } from 'sonner';
import { noteShownError, shownErrorText } from '@higgins/utils';

type ToasterProps = React.ComponentProps<typeof Sonner>;

let notingErrors = false;

/**
 * Every app shows its errors through sonner's `toast.error`, so wrapping it once, here, notes
 * each message the user saw for a Report a problem report (#660) with no app code. Apps import
 * `toast` from sonner directly; it is one shared object, so the wrapper covers them all.
 */
function noteErrorToasts(): void {
  if (notingErrors) return;
  notingErrors = true;
  const show = toast.error;
  toast.error = (message, data) => {
    if (typeof message === 'string') noteShownError(shownErrorText(message, data?.description));
    return show(message, data);
  };
}

const Toaster = ({ ...props }: ToasterProps) => {
  noteErrorToasts();
  return (
    <Sonner
      theme="light"
      className="toaster group"
      icons={{
        success: <CircleCheck className="h-4 w-4" />,
        info: <Info className="h-4 w-4" />,
        warning: <TriangleAlert className="h-4 w-4" />,
        error: <OctagonX className="h-4 w-4" />,
        loading: <LoaderCircle className="h-4 w-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
